export const optionConfigFn1 = (echarts, num, unit) => {
  const placeHolderStyle = {
    normal: {
      label: {
        show: false,
      },
      labelLine: {
        show: false,
      },
      color: "rgba(0,0,0,0)",
      borderWidth: 0,
    },
    emphasis: {
      color: "rgba(0,0,0,0)",
      borderWidth: 0,
    },
  };
  return {
    title: [
      {
        text: num,
        subtext: unit,
        x: "center",
        y: "38%",
        textStyle: {
          color: "#fff",
          fontSize: 20,
          fontWeight: "600",
          align: "center",
          // "width": "200px"
        },
        subtextStyle: {
          color: "rgba(#fff, 0.6)",
          fontSize: 10,
          fontWeight: "normal",
        },
      },
    ],

    //第一个图表
    series: [
      {
        type: "pie",
        hoverAnimation: false, //鼠标经过的特效
        radius: ["65%", "80%"],
        center: ["50%", "50%"],
        startAngle: 203,
        labelLine: {
          normal: {
            show: false,
          },
        },
        label: {
          normal: {
            position: "center",
          },
        },
        data: [
          {
            value: 100,
            itemStyle: {
              normal: {
                color: "#006294",
              },
            },
          },
          {
            value: 35,
            itemStyle: placeHolderStyle,
          },
        ],
      },
      //上层环形配置
      {
        type: "pie",
        hoverAnimation: false, //鼠标经过的特效
        radius: ["65%", "80%"],
        center: ["50%", "50%"],
        startAngle: 245,
        labelLine: {
          normal: {
            show: false,
          },
        },
        label: {
          normal: {
            position: "center",
          },
        },
        data: [
          {
            value: 175,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#a5eefc",
                  },
                  {
                    offset: 1,
                    color: "#798bf9",
                  },
                ]),
              },
            },
          },
          {
            value: 75,
            itemStyle: placeHolderStyle,
          },
        ],
      },
    ],
  };
};
